import { gql } from '@apollo/client';

export const UPLOAD_IMAGES = gql`
    mutation UploadImages($imageData: [ImageArrayType!]!) {
        uploadImages(imageData: $imageData)
    }
`;
